import { useState } from 'react';
import { GetRequestsByNPN } from '../../../api/MyIMO';
import { useQuery } from '@tanstack/react-query';
import LoadingIndicator from '../../../components/Global/loading-indicator/loading-indicator';
import ContractingDataGrid from './datagrid/ContractingDataGrid';
import NewRequestModal from './modal/NewRequestModal';
import { Typography, Box, Stack, Button, Alert } from '@mui/material';

const Contracting = ({ producerID }) => {
  const [showNewRequestModal, setShowNewRequestModal] = useState(false);

  const getRequestsByNPNResult = useQuery({
    queryKey: ['getRequestByNPN'],
    queryFn: () => GetRequestsByNPN()(),
    refetchOnWindowFocus: true,
  });

  const toggleModal = () => {
    setShowNewRequestModal((prev) => !prev);
  };

  return (
    <Box sx={{ padding: '1rem' }}>
      {getRequestsByNPNResult.isError && (
        <Box padding={'1rem 0'}>
          <Alert sx={{ width: 'fit-content' }} severity="warning">
            Something went wrong
          </Alert>
        </Box>
      )}
      <Stack
        justifyContent={'space-between'}
        alignItems={{ xs: 'flex-start', md: 'center' }}
        direction={{ xs: 'column', md: 'row' }}
      >
        <Typography component={'h3'} sx={{ padding: '1rem 0' }} variant="h6">
          Contract Requests
        </Typography>
        <Stack
          direction="row"
          gap={2}
          width={{ xs: '100%', md: 'unset' }}
          justifyContent={{ xs: 'flex-end', md: 'unset' }}
          padding={{ xs: '.5rem 0', md: 'unset' }}
        >
          {/* <Button disabled>Download Guide</Button> */}
          <Button
            onClick={toggleModal}
            sx={{ height: 'fit-content', padding: '.5rem .875rem' }}
            variant="contained"
          >
            New Contract
          </Button>
        </Stack>
      </Stack>
      {getRequestsByNPNResult.isPending ? (
        <LoadingIndicator />
      ) : (
        <ContractingDataGrid
          isLoading={getRequestsByNPNResult.isPending}
          data={getRequestsByNPNResult.data}
        />
      )}
      <NewRequestModal
        producerID={producerID}
        showModal={showNewRequestModal}
        toggleModal={toggleModal}
        refetchRequests={getRequestsByNPNResult.refetch}
      />
    </Box>
  );
};

export default Contracting;
